"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var yup = require("yup");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var operators_1 = require("rxjs/operators");
var Types_1 = require("../../../Types");
var Page_1 = require("../../Page");
var Notification_1 = require("../../Notification");
var Pagination_1 = require("../../../helpers/Pagination");
var TransactionSearchResultsTable_1 = require("./TransactionSearchResultsTable");
var moment = require("moment/moment");
var TransactionSearchPage = /** @class */ (function (_super) {
    __extends(TransactionSearchPage, _super);
    function TransactionSearchPage(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPageContent = function () {
            var formErrors = _this.state.formErrors;
            return ((0, jsx_runtime_1.jsx)("div", { className: "panel-border", children: (0, jsx_runtime_1.jsxs)("form", { onSubmit: _this.handleSubmit, autoComplete: "off", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "transactionDate", children: "Transaction Date" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group p-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", id: "transactionDate", name: "transactionDate", className: "form-control ".concat(formErrors.transactionDate ? "is-invalid" : ""), value: _this.state.form.transactionDate, placeholder: "dd/mm/yyyy", onChange: _this.handleFormChange }), formErrors.transactionDate && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: formErrors.transactionDate }))] }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", className: "mt-2", children: "Amount" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group p-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "number", id: "amount", step: "0.01", name: "amount", className: "form-control ".concat(formErrors.amount ? "is-invalid" : ""), value: _this.state.form.amount, onChange: _this.handleFormChange }), formErrors.amount && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: formErrors.amount }))] }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "cardNumber", className: "mt-2", children: "Card Number *" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group p-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", id: "cardNumber", name: "cardNumber", className: "form-control ".concat(formErrors.cardNumber ? "is-invalid" : ""), value: _this.state.form.cardNumber, placeholder: "123456******1234", onChange: _this.handleFormChange }), formErrors.cardNumber && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: formErrors.cardNumber }))] }), (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mt-3", children: "Search" })] }), (0, jsx_runtime_1.jsx)(Pagination_1.default, { limit: _this.state.limit, offset: _this.state.offset, total: _this.state.searchResult.count, onClickPrevious: _this.handleClickPrevious, onClickNext: _this.handleClickNext, onClickPageNumber: _this.handleClickPageNumber }), _this.state.isTableLoaded && !_this.state.noResultError &&
                            (0, jsx_runtime_1.jsx)(TransactionSearchResultsTable_1.default, { transactions: _this.state.searchResult.results })] }) }));
        };
        _this.handleFormChange = function (event) {
            var form = __assign({}, _this.state.form);
            var target = event.target;
            // @ts-ignore
            form[target.name] = target.value.trim();
            _this.setState({ form: form }, _this.validateForm);
        };
        _this.validateForm = function () {
            return _this.formSchema
                .validate(_this.state.form, { abortEarly: false })
                .then(function () { return _this.setState({ formErrors: {} }); })
                .catch(function (caughtErrors) {
                var formErrors = {};
                caughtErrors.inner.reverse().forEach(function (innerError) {
                    formErrors[innerError.path] = innerError.message;
                });
                _this.setState({ formErrors: formErrors });
            });
        };
        _this.isFormValid = function () {
            return Object.keys(_this.state.formErrors).length === 0;
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var form = __assign({}, _this.state.form);
            form.hasBeenSubmitted = true;
            _this.setState({ form: form }, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.validateForm()];
                        case 1:
                            _a.sent();
                            if (this.isFormValid()) {
                                this.search();
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.search = function () {
            var form = __assign({}, _this.state.form);
            form.hasBeenSubmitted = false;
            _this.setState({
                isLoading: true,
                searchResult: {
                    count: 0,
                    results: []
                },
                form: form
            }, function () {
                _this.supportPortalService.getTransactions({
                    transactionDate: _this.state.form.transactionDate === "" ? undefined : moment(_this.state.form.transactionDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                    amount: _this.state.form.amount === 0.00 ? undefined : _this.state.form.amount,
                    cardNumber: _this.state.form.cardNumber,
                    limit: _this.state.limit,
                    offset: _this.state.offset
                })
                    .pipe((0, operators_1.finalize)(function () { return _this.setState({
                    isLoading: false
                }); }))
                    .subscribe(function (searchResult) {
                    if (searchResult.count === 0) {
                        _this.showTransactionNotFound();
                    }
                    else {
                        _this.setState(function () { return ({
                            isLoading: false,
                            isTableLoaded: true,
                            searchResult: searchResult,
                            noResultError: searchResult.count === 0,
                        }); });
                    }
                }, function (error) {
                    _this.setState({
                        isLoading: false,
                        isTableLoaded: false
                    }, function () { return console.error("Something went wrong", error); });
                });
            });
        };
        _this.handleClickPrevious = function () {
            _this.setState(function (state) {
                var offset = state.offset;
                var newOffset = state.offset - state.limit;
                if (newOffset >= 0) {
                    offset = newOffset;
                }
                return { offset: offset };
            }, _this.search);
        };
        _this.handleClickNext = function () {
            _this.setState(function (state) {
                var offset = state.offset;
                var newOffset = state.offset + state.limit;
                if (newOffset < state.searchResult.count) {
                    offset = newOffset;
                }
                return { offset: offset };
            }, _this.search);
        };
        _this.handleClickPageNumber = function (pageNumber) {
            _this.setState(function (state) {
                var offset = state.offset;
                var newOffset = state.limit * (pageNumber - 1);
                if (newOffset >= 0 && newOffset < state.searchResult.count) {
                    offset = newOffset;
                }
                return { offset: offset };
            }, _this.search);
        };
        _this.handleAlertClose = function () {
            _this.setState({
                alert: {
                    show: false,
                    title: "",
                    message: ""
                }
            });
        };
        _this.showTransactionNotFound = function () {
            _this.setState({
                alert: {
                    show: true,
                    title: "Not found",
                    message: "Transaction not found"
                }
            });
        };
        _this.formSchema = yup.object({
            hasBeenSubmitted: yup.boolean(),
            transactionDate: yup
                .string()
                .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/, {
                message: "Invalid date",
                excludeEmptyString: true
            }),
            amount: yup
                .number()
                .transform(function (val, orig) { return orig === "" ? undefined : val; }),
            cardNumber: yup
                .string()
                .matches(/^\d{6}\*{6}\d{4}$/, {
                message: "Invalid card number format",
                excludeEmptyString: true
            })
                .when('hasBeenSubmitted', {
                is: true,
                then: yup.string().required("This field is mandatory")
            })
        });
        _this.state = {
            isLoading: false,
            form: {
                hasBeenSubmitted: false,
                transactionDate: "",
                amount: 0.00,
                cardNumber: ""
            },
            formErrors: {},
            alert: {
                show: false,
                title: "",
                message: ""
            },
            searchResult: {
                count: 0,
                results: []
            },
            noResultError: false,
            limit: 50,
            offset: 0,
            isTableLoaded: false
        };
        return _this;
    }
    TransactionSearchPage.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(Page_1.default, { title: "Transaction search", isLoading: this.state.isLoading, children: [(0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.alert.show, hide: this.handleAlertClose, title: this.state.alert.title, message: this.state.alert.message }), (0, jsx_runtime_1.jsx)("h1", { className: "text-white", children: "Transaction search" }), this.renderPageContent()] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], TransactionSearchPage.prototype, "supportPortalService", void 0);
    TransactionSearchPage = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], TransactionSearchPage);
    return TransactionSearchPage;
}(React.Component));
exports.default = TransactionSearchPage;
//# sourceMappingURL=TransactionSearchPage.js.map